import React from 'react';
import styled from 'styled-components';
import ReportPercentage from '../ReportPercentage';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { budgetTableGridStyles } from './ReportBudgetHeader';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { numberWithCommas } from 'shared/utils/numberUtils';
import { defaultCostValue } from 'npo/pages/ReportBuilder/Components/Budget/RelevancyCheckbox';

interface ReportBudgetRowProps {
  heading: string;
  subheading: string;
  percentage: string | number | undefined;
}

const StyledDiv = styled.div`
  ${budgetTableGridStyles}
  border-top: 1px solid ${COLORS.grayLight};
`;

const style: React.CSSProperties = { justifySelf: 'center' };
export const ReportBudgetRowWrapper: React.FC<{
  className?: string;
  children: React.ReactNode | React.ReactNode[];
}> = ({ className, children }) => {
  return <StyledDiv className={className}>{children}</StyledDiv>;
};

const ReportBudgetRow: React.FC<ReportBudgetRowProps> = ({
  heading,
  subheading,
  percentage,
}) => {
  return (
    <ReportBudgetRowWrapper>
      <TrueImpactText variant="body-small-bold">{heading}</TrueImpactText>
      <TrueImpactText variant="body-small" style={style}>
        {subheading === defaultCostValue
          ? subheading
          : `$${numberWithCommas(subheading).replace('.00', '')}`}
      </TrueImpactText>
      <ReportPercentage percentage={percentage} />
    </ReportBudgetRowWrapper>
  );
};

export default ReportBudgetRow;
